import { render, staticRenderFns } from "./PageStore.vue?vue&type=template&id=72770f22&"
import script from "./PageStore.vue?vue&type=script&lang=ts&"
export * from "./PageStore.vue?vue&type=script&lang=ts&"
import style0 from "./PageStore.vue?vue&type=style&index=0&id=72770f22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports